import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Link, Badge} from '@material-ui/core';
import {T} from 'Actions/translate';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import {
    loadProfile,
    removeProfile,
    removeIdToken,
    loadLanguage,
} from 'Utils/jwtUtil';
import {USER_ROLE} from 'Utils/constant';

// Components
import Header from 'Components/common/Header';
import Anchor from 'Components/common/Anchor';

// Actions
import {openNotification} from 'Actions/notification';
import {
    getMyOrderCount,
    getSystemNotification,
    setSystemNotification,
} from 'Actions/userCenter';
import {
    updateShipmentSearchFields,
    getUserCenterAdventQuantity,
    internalRedQuantity,
    getMsgTotal,
} from 'Actions/host';
import {
    updateProductSearchFields,
    updateCategroySelected,
    getCartCount,
} from 'Actions/order';
import {
    updateAdminF1OrderSearchFields,
    updateAdminF1OrderTabActive,
} from 'Actions/replenishment';
import {getTaskCount} from 'Actions/taskManagement';
import {setSCData} from 'Actions/localData';

// Icons
import {
    NavigateNext,
    Reorder,
    Comment,
    EventNote,
    NoEncryption,
    Assignment,
    LocalShipping,
    Block,
    Backup,
    Language,
    Sync,
    Layers,
    Assistant,
    CompareArrows,
    AddAlarm,
    AcUnit,
    Timer,
    Settings,
    BrightnessLow,
} from '@material-ui/icons';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import SmsIcon from '@material-ui/icons/Sms';
class UserCenter extends Component {
    state = {
        aboutOpened: false,
        exitOpened: false,
        exitCustomerOpened: false,
        adventQuantity: {},
        isInternalRed: false,
        yourMsg: 0,
        longDescOpenedDialog: false,
        currentNotificationList: [],
    };

    componentWillMount() {
        const {scId, localData} = this.props;
        // localData.roleType !== 2 && this.props.getMyOrderCount();

        this.props.getCartCount(localData.customerEmail);

        this.props.internalRedQuantity().then((res) => {
            if (res && res.status === 'success') {
                if (res.data > 0) {
                    this.setState({
                        isInternalRed: true,
                    });
                } else {
                    this.setState({
                        isInternalRed: false,
                    });
                }
            }
        });

        this.props.updateAdminF1OrderTabActive({$set: 0});

        this.props.updateAdminF1OrderSearchFields({
            queryKey: {$set: ''},
        });

        this.props.updateShipmentSearchFields({
            queryKey: {$set: ''},
        });

        if (localData.roleType === 2) {
            this.props.getUserCenterAdventQuantity().then((res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        adventQuantity: res.data,
                    });
                }
            });
        }

        if (localData.roleType === 2) {
            this.props.getMsgTotal().then((res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        yourMsg: res.data,
                    });
                }
            });
        }

        if (
            localData.roleType === USER_ROLE.SALES ||
            localData.roleType === USER_ROLE.HOST
        ) {
            this.props.getSystemNotification().then((res) => {
                if (res && res.data && res.data.length > 0) {
                    document.getElementById('header-background').style.height =
                        document.getElementById('header-container')
                            .clientHeight + 'px';
                }
            });
        }

        if (localData.roleType === USER_ROLE.HOST) {
            this.props.getTaskCount();
        }
    }

    openDialog = (name) => {
        this.setState({
            [name]: true,
        });
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    goToAmanda = () => {
        console.log('process.env.http_env======', process.env.http_env);
        if (process.env.http_env === 'prod') {
            this.goOtherLocation('');
        } else {
            this.goOtherLocation('qa-');
        }
    };

    goOtherLocation = (envPro) => {
        window.open('https://' + envPro + 'amanda.thermofisher.cn/', '_blank');
    };

    exit = () => {
        this.props.setSystemNotification({
            $set: [],
        });
        removeIdToken();
        removeProfile();
        window.tfsUserID = '';
        this.props.setSCData({
            id: null,
            name: null,
            type: null,
        });
        this.props.updateCategroySelected({
            key: 0,
            value: T('allProduct'),
        });
        this.props.updateProductSearchFields('');
        this.setState({exitOpened: false}, () =>
            this.props.history.push('/adminLogin'),
        );
    };

    exitCustomer = () => {
        removeIdToken();
        removeProfile();
    };

    goBack = () => {
        this.props.history.push('/productList');
    };

    goInternalTransferOrder = () => {
        // const {localData} = this.props;
        this.props.history.push('/internalTransferOrderList', 'user');
    };

    getCurrentRouterPath = () => {
        const hasUserCenterPage = window.location.href.includes('/userCenter');

        return hasUserCenterPage;
    };

    openLongDescDialog = () => {
        console.log(this.props.systemNotification);
        this.setState({
            longDescOpenedDialog: true,
            currentNotificationList: this.props.systemNotification,
        });
    };

    render() {
        const {
            aboutOpened,
            exitOpened,
            exitCustomerOpened,
            adventQuantity,
            isInternalRed,
            yourMsg,
            longDescOpenedDialog,
            currentNotificationList,
        } = this.state;
        const {
            scHostInfor,
            name,
            localData,
            cartCount,
            systemNotification,
            taskQuantitys,
        } = this.props;
        let lang = loadLanguage();
        console.log(
            'systemNotification-----------------------',
            systemNotification,
        );

        return (
            <div className="user-center-container">
                <div className="container-max-width is-fixed background"></div>

                <Header
                    cartCount={cartCount}
                    hasUserCenter={false}
                    hasShoppingCart={false}
                    hasArrowBackIos={localData.roleType === 0}
                    notificationContent={
                        (localData.roleType === USER_ROLE.SALES ||
                            localData.roleType === USER_ROLE.HOST) &&
                        this.getCurrentRouterPath()
                            ? systemNotification
                            : ''
                    }
                    openLongDescEvent={this.openLongDescDialog}
                    backEvent={this.goBack}>
                    <div className="header-content">
                        <h3
                            className={
                                (localData.roleType === USER_ROLE.SALES ||
                                    localData.roleType === USER_ROLE.HOST) &&
                                this.getCurrentRouterPath() &&
                                systemNotification &&
                                systemNotification.length > 0
                                    ? 'title add-notification-title'
                                    : 'title'
                            }>
                            {T('user_center')}
                            {process.env.http_env !== 'prod' ? (
                                <label className="test-warning">
                                    {T('user_center_test_warning_flag')}
                                </label>
                            ) : null}
                        </h3>
                        <div className="section">
                            <span className="name">{name}</span>
                        </div>
                    </div>
                </Header>

                <div className="content">
                    {localData.roleType === 3 || localData.roleType === 1 ? (
                        <section className="menu-list content-box">
                            <Anchor
                                className="menu-link no-border"
                                testid="user_center_create_order"
                                id="proxy_user_order"
                                onClickOfSingleTap={() =>
                                    // this.props.history.push(
                                    //     '/selectCustomer',
                                    // )
                                    this.props.history.push(
                                        '/purchase/selectCustomer',
                                    )
                                }>
                                <span className="menu-text">
                                    <EventNote className="icon" />
                                    {T('user_center_create_order')}
                                </span>
                                <NavigateNext className="navigate-next-icon" />
                            </Anchor>
                        </section>
                    ) : null}
                    {localData.roleType !== 2 ? (
                        <section className="my-order-info content-box">
                            <Anchor
                                className="menu-link"
                                id="my_order"
                                testid="user_center_my_order"
                                onClickOfSingleTap={() => {
                                    this.props.history.push(
                                        '/myOrderList/unreceived',
                                    );
                                }}>
                                <span className="menu-text">
                                    <EventNote className="icon" />
                                    {T('order_customer_order')}
                                </span>
                                <span className="review-all-order">
                                    {T('user_center_view_all_order')}
                                    <NavigateNext className="navigate-next-icon" />
                                </span>
                            </Anchor>

                            <Anchor
                                className="menu-link"
                                id="lang"
                                testid="user_center_lto_history_list"
                                onClickOfSingleTap={() =>
                                    this.props.history.push(
                                        '/purchase/ltoHistoryList',
                                    )
                                }>
                                <span className="menu-text">
                                    <Timer className="icon" />
                                    {T('lto_history_list')}
                                </span>
                                <NavigateNext className="navigate-next-icon" />
                            </Anchor>

                            {/* 
                            {localData.roleType === 1 ||
                            localData.roleType === 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="lang"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/purchase/ltoHistoryList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Language className="icon" />
                                            {T('lto_history_list')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null} */}

                            {/* <ul className="text-center">
                                <li>
                                    <Anchor
                                        id="to_be_shipped"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/myOrderList/unreceived',
                                            )
                                        }>
                                        <div className="number price-font">
                                            {myOrderCount.data &&
                                            myOrderCount.data.notReceivedCount
                                                ? myOrderCount.data
                                                      .notReceivedCount
                                                : 0}
                                        </div>
                                        <div className="desc">
                                            {T('user_center_not_receive')}
                                        </div>
                                    </Anchor>
                                </li>
                                <li>
                                    <Anchor
                                        id="to_be_recieved"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/myOrderList/received',
                                            )
                                        }>
                                        <div className="number price-font">
                                            {myOrderCount.data &&
                                            myOrderCount.data.receivedCount
                                                ? myOrderCount.data
                                                      .receivedCount
                                                : 0}
                                        </div>
                                        <div className="desc">
                                            {T('user_center_received')}
                                        </div>
                                    </Anchor>
                                </li>
                                <li>
                                    <Anchor
                                        id="complete"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/myOrderList/canceled',
                                            )
                                        }>
                                        <div className="number price-font">
                                            {myOrderCount.data &&
                                            myOrderCount.data.canceledCount
                                                ? myOrderCount.data
                                                      .canceledCount
                                                : 0}
                                        </div>
                                        <div className="desc">
                                            {T('user_center_canceled')}
                                        </div>
                                    </Anchor>
                                </li>
                            </ul> */}
                        </section>
                    ) : null}
                    <section className="menu-list content-box">
                        <ul>
                            {/* {localData.roleType === 1 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="fone_order"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/adminF1OrderList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Reorder className="icon" />
                                            {T('user_center_fone_order')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null} */}
                            {localData.roleType === 1 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="inventory_mangement"
                                        testid="user_center_replenishment_management"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/replenishmentMgmt',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <LocalShipping className="icon" />
                                            {T(
                                                'user_center_replenishment_management',
                                            )}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 1 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="lang"
                                        testid="user_center_internal_transfer_order"
                                        onClickOfSingleTap={() =>
                                            this.goInternalTransferOrder()
                                        }>
                                        <span className="menu-text advent-menu-text">
                                            <CompareArrows className="icon" />
                                            {T('internal_transfer_order')}
                                        </span>
                                        {localData.roleType === 2 &&
                                        isInternalRed ? (
                                            <div className="user-center-advent-quantity">
                                                <div className="red-quantity"></div>
                                            </div>
                                        ) : null}
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="shippment_management"
                                        testid="user_center_delivery_management"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push({
                                                pathname:
                                                    '/shipmentList/toBeShip',
                                                fromUserCenter: true,
                                            })
                                        }>
                                        <span className="menu-text">
                                            <LocalShipping className="icon" />
                                            {T(
                                                'user_center_delivery_management',
                                            )}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="fone_recieve"
                                        testid="user_center_fone_receive_management"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/F1OrderList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Reorder className="icon" />
                                            {T(
                                                'user_center_fone_receive_management',
                                            )}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="fone_recieve"
                                        testid="user_center_proxy_delivery_order_management"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/proxyDeliveryOrderList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <LocalShipping className="icon" />
                                            {T(
                                                'user_center_proxy_delivery_order_management',
                                            )}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="task-management"
                                        testid="user_center_task_management"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                'host/taskManagementList',
                                            )
                                        }>
                                        <span className="menu-text task-menu-text">
                                            <BrightnessLow className="icon" />
                                            {T('user_center_task_management')}
                                        </span>
                                        <div className="user-center-task-quantity">
                                            {taskQuantitys &&
                                            taskQuantitys.requiredCount > 0 ? (
                                                <Badge
                                                    count={
                                                        taskQuantitys &&
                                                        taskQuantitys.requiredCount
                                                    }
                                                    className="badge-red-quantity">
                                                    {taskQuantitys &&
                                                        taskQuantitys.requiredCount}
                                                </Badge>
                                            ) : null}
                                            {taskQuantitys &&
                                            taskQuantitys.progressCount > 0 ? (
                                                <Badge
                                                    count={
                                                        taskQuantitys &&
                                                        taskQuantitys.requiredCount
                                                    }
                                                    className="badge-yellow-quantity">
                                                    {taskQuantitys &&
                                                        taskQuantitys.progressCount}
                                                </Badge>
                                            ) : null}
                                        </div>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ||
                            localData.roleType === 1 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="fone_recieve"
                                        testid="user_center_inventory_query"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/inventoryQuery',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Layers className="icon" />
                                            {T('user_center_inventory_query')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="lockProducts"
                                        testid="user_center_hold_products"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/AdventProductsSCList',
                                            )
                                        }>
                                        <span className="menu-text advent-menu-text">
                                            <Assistant className="icon" />
                                            {T('user_center_hold_products')}
                                        </span>
                                        <div className="user-center-advent-quantity">
                                            {adventQuantity &&
                                            adventQuantity.redCnt > 0 ? (
                                                <div className="red-quantity"></div>
                                            ) : null}
                                            {adventQuantity &&
                                            adventQuantity.yellowCnt > 0 ? (
                                                <div className="yellow-quantity"></div>
                                            ) : null}
                                        </div>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="exception_reagent"
                                        testid="user_center_abnormal_reagent"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/abnormalRecordList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Block className="icon" />
                                            {T('user_center_abnormal_reagent')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        testid="user_center_view_inventory"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/replenishmentMgmt',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Reorder className="icon" />
                                            {T('user_center_view_inventory')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType == 0 ||
                            localData.roleType == 1 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="order_report"
                                        testid="user_center_order_report"
                                        onClickOfSingleTap={() => {
                                            this.props.history.push(
                                                '/orderReport',
                                            );
                                        }}>
                                        <span className="menu-text">
                                            <Assignment className="icon" />
                                            {T('user_center_order_report')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="application_backup"
                                        testid="user_center_application_backup"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/backupList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Backup className="icon" />
                                            {T(
                                                'user_center_application_backup',
                                            )}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="lang"
                                        testid="user_center_apply_for_listing"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/applyForListing',
                                                'user',
                                            )
                                        }>
                                        <span className="menu-text advent-menu-text">
                                            <CallMissedOutgoingIcon className="icon" />
                                            {T('apply_for_listing')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 3 ||
                            localData.roleType === 1 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="sync_ST"
                                        testid="user_center_account_sync"
                                        onClickOfSingleTap={() => {
                                            this.props.history.push('/syncST');
                                        }}>
                                        <span className="menu-text">
                                            <Sync className="icon" />
                                            {T('user_center_account_sync')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="application_backup"
                                        testid="user_center_application_backup"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/backupList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <Backup className="icon" />
                                            {T(
                                                'user_center_application_backup',
                                            )}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="lang"
                                        testid="user_center_st_management"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/stManagementList',
                                            )
                                        }>
                                        <span className="menu-text">
                                            <AcUnit className="icon" />
                                            {T('st_management')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}

                            {localData.roleType == 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="order_report"
                                        testid="user_center_order_report"
                                        onClickOfSingleTap={() => {
                                            this.props.history.push(
                                                '/orderReport',
                                            );
                                        }}>
                                        <span className="menu-text">
                                            <Assignment className="icon" />
                                            {T('user_center_order_report')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 3 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="contact_us"
                                        testid="user_center_amanda"
                                        onClickOfSingleTap={() => {
                                            this.goToAmanda();
                                        }}>
                                        <span className="menu-text">
                                            <Language className="icon" />
                                            {T('user_center_contact_amanda')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 1 ||
                            localData.roleType === 2 ? null : (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="feedback"
                                        testid="user_center_feedback"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push('/feedback')
                                        }>
                                        <span className="menu-text">
                                            <Comment className="icon" />
                                            {T('feedback')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            )}

                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="lang"
                                        testid="user_center_internal_transfer_order"
                                        onClickOfSingleTap={() =>
                                            this.goInternalTransferOrder()
                                        }>
                                        <span className="menu-text advent-menu-text">
                                            <CompareArrows className="icon" />
                                            {T('internal_transfer_order')}
                                        </span>
                                        {localData.roleType === 2 &&
                                        isInternalRed ? (
                                            <div className="user-center-advent-quantity">
                                                <div className="red-quantity"></div>
                                            </div>
                                        ) : null}
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="myMessage"
                                        testid="user_center_your_message"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/yourMessage',
                                            )
                                        }>
                                        <span className="menu-text advent-menu-text">
                                            <SmsIcon className="icon" />
                                            {T('user_center_your_message')}
                                        </span>
                                        {yourMsg === null ||
                                        yourMsg === 0 ? null : (
                                            <div className="user-center-advent-quantity">
                                                {/* <div className="red-quantity">
                                                    {yourMsg}
                                                </div> */}
                                                <Badge
                                                    count={yourMsg}
                                                    className="badge-red-quantity">
                                                    {yourMsg}
                                                </Badge>
                                            </div>
                                        )}
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                            {/* {localData.roleType === 2 ? (
                                <li>
                                    <Anchor
                                        className="menu-link"
                                        id="myMessage"
                                        onClickOfSingleTap={() =>
                                            this.props.history.push(
                                                '/clockedSigned',
                                            )
                                        }>
                                        <span className="menu-text advent-menu-text">
                                            <SmsIcon className="icon" />
                                            {T('user_center_clocked_signed')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null} */}

                            <li>
                                <Anchor
                                    className="menu-link"
                                    id="lang"
                                    testid="user_center_set_language"
                                    onClickOfSingleTap={() =>
                                        this.props.history.push('/language')
                                    }>
                                    <span className="menu-text">
                                        <Settings className="icon" />
                                        {T('set_language')}
                                    </span>
                                    <NavigateNext className="navigate-next-icon" />
                                </Anchor>
                            </li>

                            {localData.roleType !== 0 ? (
                                <li>
                                    <Anchor
                                        className="menu-link no-border"
                                        id="logout"
                                        testid="user_center_logout"
                                        onClickOfSingleTap={() =>
                                            this.openDialog('exitOpened')
                                        }>
                                        <span className="menu-text">
                                            <NoEncryption className="icon" />
                                            {T('exit')}
                                        </span>
                                        <NavigateNext className="navigate-next-icon" />
                                    </Anchor>
                                </li>
                            ) : null}
                        </ul>
                    </section>
                </div>

                <Dialog
                    dialogDidClose={() =>
                        this.closeDialog('longDescOpenedDialog')
                    }
                    opened={longDescOpenedDialog}
                    options={{bgClickClose: true}}>
                    <div className="view-notification-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>{T('user_center_long_desc_detail')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            style={{color: '#605f5f'}}
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={12} className="content-container">
                                {currentNotificationList &&
                                    currentNotificationList.length > 0 &&
                                    currentNotificationList.map(
                                        (
                                            notificationItem,
                                            notificationIndex,
                                        ) => {
                                            return (
                                                <div className="notification-list">
                                                    <label>
                                                        {T(
                                                            'user_center_notification_desc',
                                                        )}
                                                        :
                                                    </label>
                                                    <div>
                                                        {
                                                            notificationItem.longDesc
                                                        }
                                                    </div>
                                                </div>
                                            );
                                        },
                                    )}
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={() =>
                                        this.closeDialog('longDescOpenedDialog')
                                    }>
                                    <span>{T('user_center_close')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    dialogDidClose={() => this.closeDialog('exitOpened')}
                    opened={exitOpened}
                    options={{bgClickClose: true}}>
                    <div className="logout-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>{T('user_center_logout')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={12}>
                                <span>{T('user_center_logout_message')}</span>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.exit}>
                                    <span>{T('user_center_logout')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    dialogDidClose={() =>
                        this.closeDialog('exitCustomerOpened')
                    }
                    opened={exitCustomerOpened}
                    options={{bgClickClose: true}}>
                    <div className="logout-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>{T('user_center_logout')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={12}>
                                <span>{T('user_center_logout_message')}</span>
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={this.exitCustomer}>
                                    <span>{T('user_center_logout')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <Dialog
                    dialogDidClose={() => this.closeDialog('aboutOpened')}
                    opened={aboutOpened}
                    options={{bgClickClose: true}}>
                    <div className="contact-us-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                <span>{T('user_center_contact_us')}</span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content bottom-grid"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid
                                className="confirm-label-grid"
                                item
                                xs={lang === 'EN' ? 4 : 3}>
                                <span>{T('order_service_hot_line')}</span>
                            </Grid>
                            <Grid item xs={lang === 'EN' ? 7 : 8}>
                                <div>
                                    <Link href={'tel://8008208982'}>
                                        {T('order_service_hot_line_number')}
                                    </Link>
                                </div>
                            </Grid>
                            <Grid item xs={lang === 'EN' ? 4 : 3}></Grid>
                            <Grid item xs={lang === 'EN' ? 7 : 8}>
                                <div>
                                    <Link href={'tel://4008208982'}>
                                        {T('order_service_hot_line_number_two')}
                                    </Link>
                                </div>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content bottom-grid"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid
                                className="confirm-label-grid"
                                item
                                xs={lang === 'EN' ? 4 : 3}>
                                <span>{T('order_business_consult')}</span>
                            </Grid>
                            <Grid item xs={lang === 'EN' ? 7 : 8}>
                                <div>{T('order_business_consult_email')}</div>
                            </Grid>
                        </Grid>

                        {scHostInfor &&
                        scHostInfor.data &&
                        scHostInfor.data.length > 0 ? (
                            <Grid
                                className="dialog-content bottom-grid"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid
                                    className="confirm-label-grid"
                                    item
                                    xs={lang === 'EN' ? 4 : 3}>
                                    <span>
                                        {T('user_center_delivery_colon')}
                                    </span>
                                </Grid>
                                <Grid item xs={lang === 'EN' ? 7 : 8}>
                                    {scHostInfor.data.map((host, i) => {
                                        return (
                                            <div key={i}>
                                                {host.name}{' '}
                                                <Link
                                                    href={
                                                        'tel://' + host.mobile
                                                    }>
                                                    {host.mobile}
                                                </Link>
                                            </div>
                                        );
                                    })}
                                </Grid>
                            </Grid>
                        ) : null}
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {bind, userCenter, localData, order, taskManagement} = state;
    return {
        cartCount: order.cartCount,
        unBind: bind.unBind,
        myOrderCount: userCenter.myOrderCount,
        scHostInfor: userCenter.scHostInfor,
        email: localData.customerEmail,
        name: localData.name,
        scId: localData.scId ? localData.scId : localData.defaultScId,
        localData,
        systemNotification: userCenter.systemNotification,

        taskQuantitys: taskManagement.taskQuantitys,
    };
};

const mapDispatchToProps = {
    openNotification,
    getMyOrderCount,
    loadProfile,
    updateShipmentSearchFields,
    updateAdminF1OrderTabActive,
    updateAdminF1OrderSearchFields,
    updateProductSearchFields,
    updateCategroySelected,
    setSCData,
    getCartCount,
    getUserCenterAdventQuantity,
    internalRedQuantity,
    getMsgTotal,
    getSystemNotification,
    setSystemNotification,
    getTaskCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserCenter);
